import type { BoundaryListing, MapPageListing } from '@zoocasa/go-search';

function resolveAddressPath(bl: BoundaryListing): string {
  const raw = bl.addressUrlAbsolutePath || bl.listingUrlAbsolutePath;
  if (raw && !raw.startsWith('/real-estate/')) return raw;
  const { slug, subDivision, province } = bl;
  if (slug && subDivision && province) {
    const citySlug = `${subDivision.toLowerCase()}-${province.toLowerCase()}`;
    const addressSlug = slug.replace(`-${citySlug}`, '');
    return `/${citySlug}-real-estate/${addressSlug}`;
  }
  return raw;
}

/**
 * Maps a BoundaryListing to the MapPageListing shape expected by the
 * compliance delegate and callout components.
 */
export function boundaryListingToMapPageListing(bl: BoundaryListing): MapPageListing {
  const addressPath = resolveAddressPath(bl);
  return {
    id: bl.id,
    mls: bl.mls,
    slug: bl.slug,
    address: bl.address,
    listingType: bl.listingType,
    price: bl.price,
    soldPrice: bl.SoldPrice,
    statusId: bl.statusId,
    providerId: bl.providerId,
    position: bl.position,
    bedrooms: bl.bedrooms,
    bathrooms: bl.bathrooms,
    brokerage: bl.brokerage,
    squareFootage: bl.squareFootage,
    imageSource: bl.imageSource,
    termsOfUseRequired: bl.termsOfUseRequired,
    imageRootStorageKey: bl.imageRootStorageKey,
    addressUrlAbsolutePath: addressPath,
    listingUrlAbsolutePath: addressPath,
    expAgentId: bl.expAgentId,
    standardStatus: bl.standardStatus,
    onMarketDate: bl.onMarketDate,
    smartTags: bl.smartTags,
  };
}
